<mat-card
  ><div class="container" fxLayout="column" fxLayoutAlign="start center">
    <div style="margin-top:30px;margin-bottom:30px"><img height="80px" src="assets/images/package.svg"/></div>
    <div>
      <h2 class="mat-h2">Ónothæfir: {{ this.count }}</h2>
    </div>
  </div></mat-card
>
